const LANG_LABEL = { en: 'English', it: 'italiano' };

/**
 * Generate prompt for suggesting ideas/solutions for a node
 * @param {Object} node
 * @param {Array} existingChildren
 * @param {Array} relatedNodes - other nodes already in the map (for cross-link detection)
 * @param {string} [lang='en']
 * @returns {string}
 */
export const generateSolutionsPrompt = (node, existingChildren, relatedNodes = [], lang = 'en') => {
  const isProblem = node.type === 'problem';
  const fullContext = node.description
    ? `\n\nContesto: ${node.description}`
    : '';

  let existingText = '';
  if (existingChildren.length > 0) {
    const itemType = isProblem ? 'Già proposte' : 'Idee esistenti';
    existingText = `\n\n${itemType} — NON ripetere, proponi alternative:\n${existingChildren.map(s => `- ${s.title}: ${s.summary}`).join('\n')}`;
  }

  const relatedText = relatedNodes.length > 0
    ? `\n\nAltri nodi già in mappa (usa "relatedTo" se un'idea che generi è chiaramente la stessa entità/concetto):\n${relatedNodes.map(n => `- "${n.title}": ${n.summary}`).join('\n')}`
    : '';

  const formatNote = relatedNodes.length > 0
    ? `\n- "relatedTo" (opzionale): titolo esatto di un nodo già in mappa, solo se l'idea generata è la stessa entità vista da un altro contesto (es. stesso ruolo, stessa persona). Non abusarne.`
    : '';

  if (isProblem) {
    return `Argomento: "${node.title}" — ${node.summary}${fullContext}

Genera 3 idee concrete e pertinenti.${existingText}${relatedText}

Titoli corti (max 4 parole), summary in una frase secca.${formatNote}
Solo JSON:
\`\`\`json
[
  {"title": "...", "summary": "..."},
  {"title": "...", "summary": "..."},
  {"title": "...", "summary": "..."}
]
\`\`\`

LINGUA: rispondi in ${LANG_LABEL[lang] ?? 'English'}.`;
  } else {
    return `Idea: "${node.title}" — ${node.summary}${fullContext}

Scomponi in 3-5 idee sequenziali per implementarla.${existingText}${relatedText}

Regole:
- Ordine cronologico
- Un'azione concreta per idea
- Titoli corti e diretti (max 4 parole)
- Non numerare${formatNote}

Solo JSON array ordinato:
\`\`\`json
[
  {"title": "...", "summary": "..."},
  {"title": "...", "summary": "..."},
  {"title": "...", "summary": "..."}
]
\`\`\`

LINGUA: rispondi in ${LANG_LABEL[lang] ?? 'English'}.`;
  }
};
